const formatDate = dateString => {
  // When creating new date with format yyyy-mm-dd in js sometimes the day was one off from our timezone:
  // https://stackoverflow.com/questions/7556591/is-the-javascript-date-object-always-one-day-off
  // weird timezone offset logic here to account for that if we send in a date with that format
  if (!dateString) return '';
  const dateWithTimeZone = new Date(dateString);
  const date = new Date(dateWithTimeZone.getTime() + Math.abs(dateWithTimeZone.getTimezoneOffset() * 60000));
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
    '/' +
    (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
    '/' +
    date.getFullYear()
  );
};

const formatDateForPicker = dateString => {
  // When creating new date with format yyyy-mm-dd in js sometimes the day was one off from our timezone:
  // https://stackoverflow.com/questions/7556591/is-the-javascript-date-object-always-one-day-off
  // weird timezone offset logic here to account for that if we send in a date with that format
  const dateWithTimeZone = new Date(dateString);
  const date = new Date(dateWithTimeZone.getTime() + Math.abs(dateWithTimeZone.getTimezoneOffset() * 60000));
  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
    '-' +
    (date.getDate() > 9 ? date.getDate() : '0' + date.getDate())
  );
};
export {formatDate, formatDateForPicker};
